import { render, staticRenderFns } from "./appointmentCheck.vue?vue&type=template&id=bc0040b4&scoped=true&"
import script from "./appointmentCheck.vue?vue&type=script&lang=js&"
export * from "./appointmentCheck.vue?vue&type=script&lang=js&"
import style0 from "./appointmentCheck.vue?vue&type=style&index=0&id=bc0040b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0040b4",
  null
  
)

export default component.exports